import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useLanguageContext from '../../languages/context';
const Link = () => {
    const [language] = useLanguageContext();
    return (_jsxs(_Fragment, { children: [_jsx("a", { href: "/@template", className: "hover:bg-[#f5f5f7] p-[10px] rounded-[10px]", children: language.navBar.templates }), _jsx("a", { href: `/@terms`, className: "hover:bg-[#f5f5f7] p-[10px] rounded-[10px]", children: language.navBar.terms }), _jsx("a", { href: `/@privacy`, className: "hover:bg-[#f5f5f7] p-[10px] rounded-[10px]", children: language.navBar.privacy })] }));
};
export default Link;
